
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-consent",
      function () {
        return require("private-next-pages/customer-consent/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-consent"])
      });
    }
  